import { __extends } from "tslib";
import { logNotification } from '@microsoft/oteljs';
import { ARIA_OFFICE_TELEMETRY_TOKEN, tryCatch, voidValue } from './InternalUtils';
import { OneDSHelper } from './OneDSHelper';
import { getAppInsights, hookUp1DSNotifications } from './ApplicationInsights';
/**
 * OTelJS 1DS Sink sends telemetry using the Web 1DS sdk
 */
var OneDSSink = /** @class */ (function (_super) {
    __extends(OneDSSink, _super);
    /**
     * Constructs an 1DS Sink
     * @param persistentDataFields - Data fields to be sent with every event; these data fields are assumed to
     * be top-level static fields, and will not be prepended with "Data."
     * @param oneDSSinkProperties - Properties on the sinks
     */
    function OneDSSink(persistentDataFields, oneDSSinkProperties) {
        var _this = _super.call(this, persistentDataFields, oneDSSinkProperties) || this;
        _this.instanceId = ++OneDSSink.instanceCounter;
        // #region Private variables
        var _applicationInsights;
        // #endregion
        // #region Public functions
        _this.sendTelemetryEvent = function (telemetryEvent) {
            return tryCatch(function () {
                var event = _this.getOneDSTelemetryEvent(telemetryEvent);
                if (event && _applicationInsights) {
                    _applicationInsights.track(event);
                }
            }, voidValue);
        };
        _this.sendCustomerContent = function (_customerContentEvent) {
            return undefined;
        };
        _this.sendNonStandardEvent = function (telemetryEvent, eventType) {
            var isHandled = false;
            nonStandardEventHandlers.forEach(function (handler) {
                if (handler.canHandle(eventType)) {
                    handler.processEvent(telemetryEvent);
                    isHandled = true;
                }
            });
            if (!isHandled) {
                logNotification(0 /* LogLevel.Error */, 1 /* Category.Sink */, function () { return 'Missing Handler for ' + eventType + 'to process' + telemetryEvent.eventName; });
            }
        };
        _this.flush = function (async) {
            _applicationInsights === null || _applicationInsights === void 0 ? void 0 : _applicationInsights.flush(async);
            nonStandardEventHandlers.forEach(function (handler) {
                handler.flush(async);
            });
        };
        _this.shutdown = function () {
            try {
                _applicationInsights === null || _applicationInsights === void 0 ? void 0 : _applicationInsights.shutdown();
                nonStandardEventHandlers.forEach(function (handler) {
                    handler.shutdown();
                });
            }
            catch (e) {
                logNotification(0 /* LogLevel.Error */, 2 /* Category.Transport */, function () { return 'An error occurred on shutdown'; });
            }
        };
        // #endregion
        // #region Actual constructor stuff
        var nonStandardEventHandlers = oneDSSinkProperties.nonStandardEventHandlers || [];
        _applicationInsights = getAppInsights(oneDSSinkProperties, ARIA_OFFICE_TELEMETRY_TOKEN);
        // Initialize each special event handler
        nonStandardEventHandlers.forEach(function (handler) {
            handler.initialize(_this, oneDSSinkProperties);
        });
        if (!oneDSSinkProperties.endpointUrl) {
            throw new Error('Missing Endpoint Url');
        }
        if (!oneDSSinkProperties.disableStatsTracking) {
            hookUp1DSNotifications(_this, _applicationInsights);
        }
        return _this;
        // #endregion
    }
    OneDSSink.instanceCounter = 0;
    return OneDSSink;
}(OneDSHelper));
export { OneDSSink };
//# sourceMappingURL=OneDSSink.js.map